import * as React from "react";

export class PulseLoading extends React.Component<{}, {}> {
    render() {
        return (
            <div className="rj-pulse-bet-markets__pulse-loading"></div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/components/PulseLoading/PulseLoading.tsx